import React from 'react'
import Header from './components/Header/Header'
import Body from './components/Body/Body'
import { WindowContainer } from './Deal.style'
import useDealMessageHandler from './hook/useDealMessageHandler'

const Deal = () => {
  const { data } = useDealMessageHandler()
  return (
    <WindowContainer>
      <Header title={data.title} />
      {Object.keys(data).length && <Body data={data} />}
    </WindowContainer>
  )
}

export default Deal
